import gql from "graphql-tag";
const LOGIN = gql `
  mutation login($loginInput: LoginInput!) {
    login(loginInput: $loginInput) {
      token
    }
  }
`;
export default LOGIN;
